import { render, staticRenderFns } from "./accountRegist.vue?vue&type=template&id=010da0bf&scoped=true&"
import script from "./accountRegist.vue?vue&type=script&lang=js&"
export * from "./accountRegist.vue?vue&type=script&lang=js&"
import style0 from "./accountRegist.vue?vue&type=style&index=0&id=010da0bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010da0bf",
  null
  
)

export default component.exports